import type { ReactNode } from "react";
import { cx } from "./cx";

export interface AlertProps {
  tone?: "neutral" | "success" | "warning" | "danger";
  title: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
}

/** 页内持续状态，一个页面最多一条。一次性反馈用 Toast。 */
export function Alert({ tone = "neutral", title, children, actions }: AlertProps) {
  return (
    <div className={cx("ax-alert", tone !== "neutral" && `ax-alert-${tone}`)} role={tone === "danger" ? "alert" : "status"}>
      <div>
        <div className="ax-alert-title">{title}</div>
        {children && <div className="ax-alert-body">{children}</div>}
        {actions && <div className="ax-alert-actions">{actions}</div>}
      </div>
    </div>
  );
}
